
import get from 'lodash/get';
import VLazyImage from 'v-lazy-image';
import { DEAL_PLACEHOLDER_IMG } from '@/constants/global';
import SumoDayBadge from '~/static/sumoday-badge.svg?inline';
import BlackFridayBadge from '~/static/campaigns/black-friday-badge.svg?inline';
import { isWishlistCollectionSlug } from '~/util/global';
import DealBanner from '../utilities/DealBanner.vue';
import DealRating from '../utilities/DealRating.vue';
import WishlistsButton from '../wishlists/Button.vue';
import CampaignsMixin from '~/mixins/campaigns';

export default {
  components: {
    DealBanner,
    DealRating,
    VLazyImage,
    SumoDayBadge,
    BlackFridayBadge,
    WishlistsButton,
  },
  mixins: [CampaignsMixin],
  props: {
    deal: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    isCarousel: {
      type: Boolean,
    },
  },
  computed: {
    lazyPlaceholderImage() {
      return DEAL_PLACEHOLDER_IMG;
    },
    isWishlistCollection() {
      return isWishlistCollectionSlug(this.$route?.params.pathMatch);
    },
    wishlistData() {
      return this.$store.getters['wishlists/wishlist'];
    },

  },
  methods: {
    onClickTile(isNewWindow = false) {
      if (!this.isCarousel) {
        if (isNewWindow) {
          window.open(this.deal.get_absolute_url);
        } else {
          this.$router.push(this.deal.get_absolute_url);
        }
      }
    },
    getPlanType(deal) {
      let textStr = '';
      if (deal.unique_plan_types) {
        for (let i = 0; i < deal.unique_plan_types.length; i += 1) {
          const typeArr = deal.unique_plan_types[i];
          if (typeArr[0] === 'One Time Purchase') {
            textStr += 'Lifetime deal';
          } else if (typeArr[0] === 'Limited License') {
            textStr += `${typeArr[2]} ${typeArr[1]} DEAL`;
          } else {
            textStr += typeArr[0];
          }
          if (i < deal.unique_plan_types.length - 1) {
            textStr += ' & ';
          }
        }
      }
      return textStr;
    },
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
    isOriginals(deal) {
      return (get(deal, 'internal_tags', []) || []).includes('originals');
    },
  },
};
